import React, { ReactNode } from 'react'
import { cn } from 'src/lib/utils'

interface SeriesCardContentProps {
  children: ReactNode
  className?: string
}

export const SeriesCardContent = ({ children, className }: SeriesCardContentProps): React.ReactElement => {
  return <div className={cn('flex flex-col justify-between h-full p-3 !md:p-2 !lg:p-3', className)}>{children}</div>
}
